(() => {
  const api = 'https://pro-skijor-team-manager.onrender.com/api/public/teams';
  const el = (tag, cls, value) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (value != null) node.textContent = value;
    return node;
  };
  const stored = key => { try { return localStorage.getItem(key) === '1'; } catch { return false; } };
  const likedThisPage = new Set();
  async function list(key) {
    const response = await fetch(api + '?event=' + encodeURIComponent(key), {headers:{Accept:'application/json'}});
    if (!response.ok) throw Error('Team feed unavailable');
    const data = await response.json();
    const unique = new Map();
    for (const t of (Array.isArray(data.teams) ? data.teams : [])) {
      const name=String(t?.teamName || '').trim();
      if (t?.handle && name && !/^(?:to be determined|tbd|unnamed(?: team)?|team name pending)(?:[\s#-]*\d+)?$/i.test(name) && Array.isArray(t.publicEventKeys) && t.publicEventKeys.some(k => String(k).toLowerCase() === key)) unique.set(t.handle,{...t,teamName:name});
    }
    return [...unique.values()];
  }
  function shuffled(teams) {
    const next = teams.slice();
    for (let i = next.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [next[i], next[j]] = [next[j], next[i]];
    }
    return next;
  }
  const placeholder='https://pro-skijor-team-manager.onrender.com/assets/team-photo-coming-soon.png?v=official-logo-20261016';
  function card(t,key,note) {
    const a=el('article','ps-team-card'),link=el('a','ps-card-link');
    const params=new URLSearchParams({team:t.publicSlug||t.handle,event:key});
    if(t.id)params.set('profile_id',t.id);
    link.href='/pages/meet-the-teams-1?'+params.toString();
    link.setAttribute('aria-label','View '+t.teamName+' profile');
    const wrap=el('div','ps-team-photo-wrap'),photo=el('img','ps-team-photo');
    const provided=typeof t.featureImage==='string'?t.featureImage:t.featureImage?.url||t.featureImage?.src||t.featureImage?.image_url;
    photo.src=t.hasUploadedFeatureImage===false||!/^https:\/\//i.test(provided||'')?placeholder:provided;
    photo.alt=photo.src===placeholder?'Team photo coming soon':t.teamName+' team photo';
    photo.loading='lazy';photo.width=800;photo.height=600;
    photo.addEventListener('error',()=>{if(photo.src!==placeholder){photo.src=placeholder;photo.alt='Team photo coming soon';}},{once:true});
    wrap.append(photo);
    if(t.isProTourTeam)wrap.append(el('span','ps-pro-badge','TEAM PRO CARD'));
    wrap.append(el('span','ps-team-view','VIEW TEAM PROFILE'));
    const copy=el('div','ps-team-copy'),facts=el('div','ps-team-facts');
    copy.append(el('div','ps-team-division',t.division||'PRO Skijor Team'),el('h3','',t.teamName));
    if(t.teamMotto)copy.append(el('p','ps-team-motto','“'+t.teamMotto+'”'));
    function fact(label,value){if(!value)return;const row=el('div');row.append(el('strong','',label+':'),document.createTextNode(' '+value));facts.append(row);}
    if(t.division!=='Big Air')fact('Rider',t.riderName);
    fact(t.athleteType||'Skier / Snowboarder',t.athleteName);
    if(t.division!=='Big Air')fact('Horse',t.horseName);
    copy.append(facts);link.append(wrap,copy);a.append(link);
    const actions=el('div','ps-team-actions'),heart=el('button','ps-heart'),share=el('button','ps-share','SHARE');
    heart.type='button';share.type='button';heart.dataset.heartTeam=t.handle;
    heart.setAttribute('aria-label','Heart '+t.teamName);
    share.setAttribute('aria-label','Share '+t.teamName+' profile');
    const icon=el('span','','♥'),count=el('b');icon.setAttribute('aria-hidden','true');
    heart.append(icon,document.createTextNode(' '),count,el('span','ps-sr-only',' fan hearts'));
    const storageKey='ps-heart-'+t.handle;
    const paint=()=>{const liked=stored(storageKey)||likedThisPage.has(t.handle);count.textContent=String(Number(t.heartCount)||0);heart.classList.toggle('is-liked',liked);heart.setAttribute('aria-pressed',String(liked));};
    paint();actions.append(heart,share);a.append(actions);
    heart.addEventListener('click',async()=>{
      if(stored(storageKey)||likedThisPage.has(t.handle)){note.textContent='You already gave this team a heart.';return;}
      heart.disabled=true;
      try{
        const response=await fetch(api+'/'+encodeURIComponent(t.handle)+'/heart',{method:'POST'});
        if(!response.ok)throw Error('Heart failed');
        const data=await response.json();
        if(!Number.isFinite(Number(data.heartCount)))throw Error('No count');
        t.heartCount=Number(data.heartCount);likedThisPage.add(t.handle);
        try{localStorage.setItem(storageKey,'1');}catch{}
        paint();note.textContent='Thanks for cheering on '+t.teamName+'!';
      }catch{note.textContent='Could not add your heart right now. Please try again.';}
      finally{heart.disabled=false;}
    });
    share.addEventListener('click',async()=>{
      try{
        if(navigator.share){await navigator.share({title:t.teamName+' | PRO Skijor',text:'Meet '+t.teamName+' on PRO Skijor.',url:link.href});note.textContent='Team profile shared.';}
        else if(navigator.clipboard){await navigator.clipboard.writeText(link.href);share.textContent='LINK COPIED';note.textContent='Team profile link copied.';setTimeout(()=>{share.textContent='SHARE';},1800);}
        else note.textContent='Open the team profile and copy its web address to share it.';
      }catch(error){if(error?.name!=='AbortError')note.textContent='Open the team profile and copy its web address to share it.';}
    });
    return a;
  }
  async function start(root) {
    if(root.dataset.featuredReady)return;
    root.dataset.featuredReady='true';
    const key=root.dataset.featuredEvent,grid=root.querySelector('[data-featured-grid]'),heading=root.querySelector('[data-featured-heading]'),note=root.querySelector('[data-featured-note]'),more=root.querySelector('[data-featured-shuffle]');
    let activeKey=key,pool;
    try{
      pool=await list(key);
      if(!pool.length&&key==='lake-tahoe'){
        activeKey='lake-tahoe-community';
        pool=await list(activeKey);
        heading.textContent='Featured Tahoe Community teams';
        note.textContent='Championship teams will appear once the Finals field is published.';
      }
    }catch{note.textContent='Featured profiles are temporarily unavailable. Open the team directory to browse.';return;}
    if(!pool.length){if(!note.textContent)note.textContent='Featured teams will appear here as profiles are published.';return;}
    let rotation=shuffled(pool),cursor=0;
    function show(){
      const selection=rotation.slice(cursor,cursor+3);
      grid.replaceChildren(...selection.map(t=>card(t,activeKey,note)));
      cursor+=selection.length;
      if(cursor>=rotation.length){rotation=shuffled(pool);cursor=0;}
    }
    show();heading.hidden=false;more.hidden=pool.length<=3;
    more.addEventListener('click',()=>{show();note.textContent=activeKey==='lake-tahoe-community'?'Showing more Tahoe Community teams. The Championship field will appear once it is published.':'Showing more teams for this event.';});
  }
  const init=()=>document.querySelectorAll('[data-featured-event]').forEach(start);
  init();document.addEventListener('shopify:section:load',init);
})();